import { mapActions, mapGetters, mapState } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { range } from 'lodash';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  props: {
    isNewArrival: {
      type: Boolean,
      default: false,
    },
    isTopTrending: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 3,
    },
  },
  components: {
    marketListItem: marketListItemV2,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('browse', [
      'mostPredictedMarkets', 'newArrivalMarkets', 'trendingMarkets',
    ]),
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      return range(0, this.num);
    },
    items() {
      if (this.isNewArrival) {
        return this.newArrivalMarkets;
      }
      if (this.isTopTrending) {
        return this.trendingMarkets;
      }
      return this.mostPredictedMarkets;
    },
    title() {
      if (this.isNewArrival) {
        return 'New Arrivals';
      }
      if (this.isTopTrending) {
        return 'Top Trending';
      }
      return 'Most Predicted';
    },
    isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === (this.num - 1);
    },
    prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true,
        // 'most-predicted-list__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true,
        // 'most-predicted-list__header-arrow--disabled': this.isNextArrowDisabled,
      };
    },
  },
  methods: {
    ...mapActions('browse', [
      'getMostPredictedMarkets', 'getNewArrivalMarkets',
      'getTrendingMarkets',
    ]),
    prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    },
  },
  mounted() {
    const payload = {
      limit: this.num,
    };
    let promise = this.getMostPredictedMarkets;

    if (this.isNewArrival) {
      promise = this.getNewArrivalMarkets;
    }

    if (this.isTopTrending) {
      promise = this.getTrendingMarkets;
    }

    this.loaderAdd();

    promise(payload)
      .then(() => {
        this.loaderRemove();
        this.isComponentReady = true;
      })
      .catch(() => this.loaderRemove());
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/most-predicted-list/most-predicted-list.js